import React from "react";
import {Card, Col, Row} from "react-bootstrap";
import {Link} from "@inertiajs/react";
import {PiArrowSquareOut} from "react-icons/pi";
import HeaderWithHelp from "../../Components/SalesAnalysis/HeaderWithHelp.jsx";
import DocumentsLayout from "../../Components/Documents/DocumentsLayout.jsx";

/**
 * Generische Dokumente-Seite: Link-Kacheln je Abschnitt (aus document_links)
 * und, bei Gliederungsknoten, die Liste der Unterseiten. Jede Kachel öffnet in
 * neuem Tab und erklärt sich per Tooltip.
 */
export default function Page({title, sections, children: unterseiten}) {
    return (
        <DocumentsLayout>
            <h1 className="h4 mb-3">{title}</h1>

            {unterseiten.length > 0 && (
                <ul className="list-unstyled documents-subpages mb-4">
                    {unterseiten.map((kind) => (
                        <li key={kind.id} className="mb-1">
                            <Link href={`/documents/${kind.path}`}>{kind.title}</Link>
                        </li>
                    ))}
                </ul>
            )}

            {sections.map((section) => (
                <section key={section.title} className="mb-4 documents-section">
                    {section.title && <h2 className="h5 mb-3">{section.title}</h2>}
                    <Row className="g-3">
                        {section.links.map((link) => (
                            <Col key={link.id} xs={12} md={6} xl={4}>
                                <Card className="h-100 documents-tile shadow-sm">
                                    <Card.Body className="d-flex flex-column">
                                        <Card.Title className="h6 mb-2">
                                            <HeaderWithHelp help={link.tooltip} placement="top">
                                                {link.title}
                                            </HeaderWithHelp>
                                        </Card.Title>
                                        {link.note && <Card.Text className="text-muted small mb-3">{link.note}</Card.Text>}
                                        <a
                                            href={link.url}
                                            target="_blank"
                                            rel="noopener"
                                            className="btn btn-primary mt-auto d-inline-flex align-items-center justify-content-center gap-2 documents-tile-link"
                                        >
                                            Öffnen
                                            <PiArrowSquareOut aria-hidden="true" />
                                        </a>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </section>
            ))}
        </DocumentsLayout>
    );
}
